<template>
    <div>
        <div v-if="alertMessage" class="notice" :class="`notice-${alertType}`">
            {{ alertMessage }}
        </div>
        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <button v-on:click="sendMessage(props.row)" class="btn btn-success text-white margin5" :disabled="props.row.send_status === 'sent'">
                        <i class="fas fa-paper-plane"></i> Kirim
                    </button>
                    <button v-on:click="sendManual(props.row)" class="btn btn-primary text-white margin5">
                        <i class="fas fa-edit"></i> Manual
                    </button>
                </span>
                <span v-else-if="props.column.field == 'send_status'">
                    <span v-if="props.row.send_status === 'sent'" class="badge badge-success">Terkirim</span>
                    <span v-else-if="props.row.send_status === 'failed'" class="badge badge-danger">Gagal</span>
                    <span v-else class="badge badge-warning text-white">Pending</span>
                </span>
                <span v-else-if="props.column.field == 'birth_date'">
                    {{ formatDate(props.row.birth_date) }}
                </span>
            </template>
        </vue-good-table>
        <modal name="sendManual" :height="'auto'" :adaptive="true" :scrollable="true">
            <div style="margin: 20px">
                <h4>Kirim Manual</h4>
                <div class="form-group">
                    <label>Template:</label>
                    <select v-model="selectedTemplate" class="form-control">
                        <option value="">Pilih Template</option>
                        <option v-for="template in templates" :key="template.id" :value="template.id">{{ template.title }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Device:</label>
                    <select v-model="selectedDevice" class="form-control">
                        <option value="">Pilih Device</option>
                        <option v-for="device in devices" :key="device.id" :value="device.id">{{ device.name }}</option>
                    </select>
                </div>
                <button v-on:click="confirmSend" class="btn btn-primary btn-block">Kirim</button>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            table: {
                isLoading: false,
                columns: [
                    { label: 'Nama', field: 'name', sortable: true },
                    { label: 'Nomor WhatsApp', field: 'number', sortable: true },
                    { label: 'Tanggal Lahir', field: 'birth_date', sortable: true },
                    { label: 'Status', field: 'send_status', sortable: true },
                    { label: 'Aksi', field: 'action', sortable: false }
                ],
                rows: [],
                total_records: 0,
                serverParams: {
                    page: 1,
                    limit: 10,
                    filter: 'today'
                }
            },
            selectedContact: null,
            selectedTemplate: null,
            selectedDevice: null,
            templates: [],
            devices: [],
            alertMessage: null,
            alertType: 'warning'
        };
    },
    beforeDestroy() {
        this.$root.$off("refresh_table", this.fn);
    },
    mounted() {
        this.fn = () => {
            this.loadItems();
        };
        this.$root.$on("refresh_table", this.fn);
        this.loadTemplates();
        this.loadDevices();
    },
    methods: {
        async loadItems() {
            this.table.isLoading = true;
            try {
                const params = {
                    ...this.table.serverParams,
                    filter: this.$parent.filter || 'today'
                };
                let response = await this.$store.dispatch("birthday/birthday_list", params);
                this.table.rows = response.data.data.birthdays || [];
                this.table.total_records = response.data.data.birthdays?.length || 0;
            } catch (err) {
                this.$toast.error("Gagal memuat data");
            }
            this.table.isLoading = false;
        },
        async loadTemplates() {
            try {
                let response = await this.$store.dispatch("birthday/birthday_template_list", { limit: 100, page: 1 });
                this.templates = response.data.data.templates || [];
                this.updateTemplateNotice();
            } catch (err) {
                this.templates = [];
                this.updateTemplateNotice(true);
            }
        },
        async loadDevices() {
            try {
                let response = await this.$store.dispatch("device_list_all");
                this.devices = response.data.data.devices || [];
            } catch (err) {
                // Ignore
            }
        },
        async sendMessage(row) {
            try {
                if (this.templates.length > 0) {
                    this.alertMessage = null;
                }
                await this.$store.dispatch("birthday/birthday_send", {
                    contact_id: row.id,
                    device_id: this.devices[0]?.id || null
                });
                this.$toast.success("Pesan berhasil dikirim");
                this.loadItems();
            } catch (err) {
                this.handleSendError(err);
            }
        },
        sendManual(row) {
            this.selectedContact = row;
            this.selectedTemplate = null;
            this.selectedDevice = null;
            this.$modal.show("sendManual");
        },
        async confirmSend() {
            if (!this.selectedDevice) {
                this.$toast.error("Pilih device terlebih dahulu");
                return;
            }
            try {
                if (this.templates.length > 0) {
                    this.alertMessage = null;
                }
                await this.$store.dispatch("birthday/birthday_send", {
                    contact_id: this.selectedContact.id,
                    template_id: this.selectedTemplate || null,
                    device_id: this.selectedDevice
                });
                this.$toast.success("Pesan berhasil dikirim");
                this.$modal.hide("sendManual");
                this.loadItems();
            } catch (err) {
                this.handleSendError(err);
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '-';
            
            // Parse date from YYYY-MM-DD format
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            
            // Format to "01 Januari 2003" (Indonesian format with leading zero)
            const months = [
                "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                "Juli", "Agustus", "September", "Oktober", "November", "Desember"
            ];
            
            const day = String(date.getDate()).padStart(2, '0');
            const month = months[date.getMonth()];
            const year = date.getFullYear();
            
            return `${day} ${month} ${year}`;
        },
        updateParams(newProps) {
            this.table.serverParams = Object.assign({}, this.table.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ limit: params.currentPerPage });
            this.loadItems();
        },
        onSortChange() {
            // Handle sort if needed
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.loadItems();
        },
        handleSendError(err) {
            const message = err?.response?.data?.message || "Gagal mengirim pesan";
            if (message.toLowerCase().includes("template")) {
                this.alertMessage = "Template pesan tidak ditemukan, silakan buat template untuk memulai mengirim ucapan";
                this.alertType = 'warning';
            }
            this.$toast.error(message);
        },
        updateTemplateNotice() {
            if (this.templates.length === 0) {
                this.alertMessage = "Template pesan tidak ditemukan, silakan buat template untuk memulai mengirim ucapan";
                this.alertType = 'warning';
            } else {
                this.alertMessage = null;
            }
        }
    }
};
</script>

<style scoped>
.margin5 {
    margin: 5px;
}
.notice {
    padding: 12px 16px;
    margin-bottom: 12px;
    border-radius: 6px;
    border: 1px solid transparent;
    background: #f3f4f6;
    color: #374151;
}
.notice-warning {
    border-color: #facc15;
    background: #fef3c7;
    color: #92400e;
}
.notice-success {
    border-color: #34d399;
    background: #d1fae5;
    color: #065f46;
}
.notice-close {
    background: transparent;
    border: none;
    color: inherit;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    margin-left: 12px;
}
.notice {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>

